import { useQuery } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { Box } from 'src/components/Box';
import { Loader } from 'src/components/Loader';
import { Meta } from 'src/components/Meta';
import { Typography } from 'src/components/Typography';
import { useSession } from 'src/contexts/SessionContext';
import { fetchActivityById } from 'src/models/activity/activity';
import { ActivityItem } from 'src/shared/ActivityItem/ActivityItem';
import { AppFrameConfig } from 'src/shared/AppFrame/AppFrameConfig';

const ActivitySinglePage = () => {
  const { activityId } = useParams<{ activityId: string }>();
  const { session } = useSession();
  const { t } = useTranslation('translation', { keyPrefix: 'activity' });

  const { data, isLoading, isError } = useQuery({
    queryKey: ['activity', activityId],
    queryFn: () => fetchActivityById(activityId!),
    enabled: !!activityId,
  });

  const pageTitle = t('title');

  return (
    <>
      <Meta title={pageTitle} brand={session?.brand} />
      <AppFrameConfig
        id="activity-single-page"
        containerMaxWidth="xl"
        title={pageTitle}
      />
      <Box sx={{ maxWidth: 720, mx: 'auto', px: 2, pb: 3, width: '100%' }}>
        {isLoading && (
          <Box display="flex" justifyContent="center" p={4}>
            <Loader size="medium" />
          </Box>
        )}
        {isError && (
          <Box p={4}>
            <Typography variant="body1" color="error" align="center">
              {t('notFound')}
            </Typography>
          </Box>
        )}
        {!isLoading && !isError && data && (
          <ActivityItem
            activity={data}
            dateFormatter="long"
            defaultExpandComments
            showNote
          />
        )}
      </Box>
    </>
  );
};

export default ActivitySinglePage;
